import './index.scss'
import React from 'react'
import Content from 'app/site/components/content'

// 我们的团队
const TeamMembers = (props) => {
  return [{
    uid: 'team_members-1',
    html:(
      <div className="section-team-members">
        <div className="container">
          <h2 className="section-title">{props.title.content}</h2>
          <div className="row">
            {props.list.items.map((item, index) =>
              <div key={index} className="col-xs-6 col-sm-4">
                <div className="team-member">
                  <div className="team-member-avatar"><Content {...item.media} className="media-object"/></div>
                  <div className="team-member-title">{item.title.content}</div>
                  <div className="team-member-subtitle">{item.subtitle.content}</div>
                  <div className="team-member-description">{item.description.content}</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }, {
    uid: 'team_members-2',
    customize: {
      backgroundColor: '#f2f2f2'
    },
    html:(
      <div className="section-team-members-2">
        <div className="container">
          <h2 className="section-title">{props.title.content}</h2>
          <div className="row">
            {props.list.items.map((item, index) =>
              <div key={index} className="col-xs-6 col-sm-3">
                <div className="team-member">
                  <div className="team-member-avatar"><Content {...item.media} className="media-object"/></div>
                  <div className="team-member-title">{item.title.content}</div>
                  <div className="team-member-subtitle">{item.subtitle.content}</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }]
}

export default TeamMembers


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/team_members/index.js